"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Matcher = void 0;
var Matcher = /** @class */ (function () {
    function Matcher(params) {
        if (params === void 0) { params = {}; }
        var projectName = params.projectName, mcsRunEnv = params.mcsRunEnv;
        this.projectName = projectName;
        this.mcsRunEnv = mcsRunEnv;
    }
    Matcher.prototype.matches = function (setting, context) {
        var _this = this;
        if (context === void 0) { context = {}; }
        var filters = setting.filter;
        var url = context.url, path = context.path, email = context.email, ip = context.ip, sessionId = context.sessionId, instanceId = context.instanceId;
        if (!filters) {
            return true;
        }
        var filterKeys = Object.keys(filters);
        return filterKeys.every(function (filter) {
            var criteria = String(filters[filter]);
            switch (filter) {
                case 'application':
                    return match(_this.projectName, criteria);
                case 'environment':
                    return matchEnvironment(criteria);
                case 'server':
                    return false;
                case 'url':
                    return match(url, criteria);
                case 'host':
                    return false;
                case 'url-path':
                    return match(path, criteria);
                case 'email':
                    return match(email, criteria);
                case 'ip':
                    return match(ip, criteria);
                case 'context':
                    return matchContext(context.context, criteria);
                case 'mcs_run_env':
                    return match(_this.mcsRunEnv, criteria);
                case 'in_browser':
                case 'unique_by_request':
                    return true;
                /** @deprecated {@link 'instance-id'} */
                case 'request-id':
                    return matchEqual(context.requestId, criteria);
                case 'session-id':
                    return matchEqual(sessionId, criteria);
                case 'instance-id':
                    return matchEqual(instanceId, criteria);
                default:
                    return false;
            }
        });
    };
    return Matcher;
}());
exports.Matcher = Matcher;
function matchEnvironment(condition) {
    return matchSet({
        set: process.env,
        condition: condition,
        useUppercaseNames: true,
    });
}
function matchContext(userCtx, condition) {
    return matchSet({
        set: userCtx,
        condition: condition,
        useUppercaseNames: false,
    });
}
function matchSet(params) {
    var set = params.set, condition = params.condition, useUppercaseNames = params.useUppercaseNames;
    if (typeof set !== 'object') {
        return false;
    }
    if (typeof condition !== 'string') {
        return false;
    }
    var parts = condition.split(',').map(function (str) { return str.trim(); });
    if (!parts.length) {
        return false;
    }
    return parts.every(function (filter) {
        var _a = __read(filter.split('='), 2), filterName = _a[0], filterValue = _a[1];
        var setValue = set[useUppercaseNames ? filterName.toUpperCase() : filterName];
        return match(setValue, filterValue);
    });
}
function match(value, criteria) {
    if (!value || !criteria) {
        return false;
    }
    return RegExp(criteria).test(value);
}
function matchEqual(value, criteria) {
    if (!value || !criteria) {
        return false;
    }
    return criteria === value;
}
//# sourceMappingURL=matcher.js.map